<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="codTipoTasa" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.frecuencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="frecuencia" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.modalidad}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="modalidad" class="form-control">
                            <option value="">{{ labels.select }}</option>
                            <option value="A">{{ labels.anticipada }}</option>
                            <option value="F">{{ labels.fija }}</option>
                            <option value="V">{{ labels.vencida }}</option>
                        </select>
                    </b-col>
                </b-row>                
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarTipoTasa">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>

import TipoTasa from '../../../services/TipoTasas';

export default {
    name: 'Crear',
    props: ['modalCrear'],
    data:() => ({
        codTipoTasa : null,
        descripcion : '',
        frecuencia : 0,
        modalidad : ''
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear Tasa',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    frecuencia : 'Frecuencia',
                    modalidad : 'Modalidad',
                    select : 'Seleccione...',
                    anticipada : 'Anticipada',
                    fija : 'Fija',
                    vencida : 'Vencida'
                }
            }else{
                return {
                    title : 'Create Rate',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code',
                    descripcion : 'Description',
                    frecuencia : 'Frecuency',
                    modalidad : 'Type',
                    select : 'Select...',
                    anticipada : 'Anticipated',
                    fija : 'Fixed',
                    vencida : 'Expire'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTipoTasa(){
            const dataForm = [
                this.codTipoTasa,
                this.descripcion,
                this.frecuencia,
                this.modalidad
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'codigo' : this.codTipoTasa,
                    'descripcion' : this.descripcion,
                    'frecuencia' : this.frecuencia,
                    'modalidad' : this.modalidad,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);
                TipoTasa.createTipoTasa(info)
                .then((res) => {

                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo tasa ingresada ya existe.')
                    }
                })
                .catch((err) => console.log(err))
            }
        }
    }
}
</script>

<style>

</style>
